<div *ngIf="items" class="list-container">
    <mat-list-item *ngFor="let item of items; let ind = index" (click)="loadContent(item,ind)" [ngClass]="{active: isActive(item)}">
        <mat-icon *ngIf="icons" matListItemIcon>folder</mat-icon>
        <div matListItemTitle>{{item?.descrizione}}</div>
    </mat-list-item>
</div>